import { render } from "./NavigatorDataTable.vue?vue&type=template&id=10e2ee50&scoped=true"
import script from "./NavigatorDataTable.vue?vue&type=script&lang=js"
export * from "./NavigatorDataTable.vue?vue&type=script&lang=js"

import "./NavigatorDataTable.vue?vue&type=style&index=0&id=10e2ee50&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e2ee50"],['__file',"resources/js/components/NavigatorDataTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10e2ee50"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10e2ee50', __exports__)) {
    api.reload('10e2ee50', __exports__)
  }
  
  module.hot.accept("./NavigatorDataTable.vue?vue&type=template&id=10e2ee50&scoped=true", () => {
    api.rerender('10e2ee50', render)
  })

}


export default __exports__